import { render, staticRenderFns } from "./download-file.vue?vue&type=template&id=f7fc4942&scoped=true"
import script from "./download-file.vue?vue&type=script&lang=js"
export * from "./download-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fc4942",
  null
  
)

export default component.exports